module.exports = __webpack_public_path__ + "img/leftArrowWhite.90713107.svg";